module.exports = __webpack_public_path__ + "static/img/es.96c30a1e.png";